import { type ComponentStyleConfig, theme } from "@chakra-ui/theme";

export const Modal: ComponentStyleConfig = theme.components.Modal;
